import request from '../../utils/request';

export function getCarrierRules(params) {
  return request(`/carrier-rules`, {
    method: 'GET',
    params,
  });
}

export function getCarrierRule(input) {
  const { ...params } = input;

  return request(`/carrier-rules`, {
    method: 'GET',
    params,
  });
}

export function createCarrierRule(params) {
  return request(`/carrier-rules`, {
    method: 'POST',
    data: params,
  });
}

export function updateCarrierRule(params) {
  const { id, ...data } = params;

  return request(`/carrier-rules/${id}`, {
    method: 'PATCH',
    data,
  });
}

export function deleteCarrierRule(params) {
  const { id } = params;
  return request(`/carrier-rules/${id}`, {
    method: 'DELETE',
  });
}
